export default __webpack_public_path__ + "img/square_3.de1872b0481ff9b0f2bf334ab0024c4b.jpg";